import { render, staticRenderFns } from "./discipline-table.vue?vue&type=template&id=d4cacd44&scoped=true&"
import script from "./discipline-table.ts?vue&type=script&lang=ts&"
export * from "./discipline-table.ts?vue&type=script&lang=ts&"
import style0 from "./discipline-table.scss?vue&type=style&index=0&id=d4cacd44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cacd44",
  null
  
)

export default component.exports